import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';
import { MdbRippleModule } from 'src/lib/mdb5-adapted/public-api';
import { AreaModel } from 'src/app/core/models/region.model';

import { LMS_NoSpecialsDirective, LmsModalFrameComponent, UpperCaseInputDirective } from '@lmsSharedUI';

@Component({
  selector: 'app-area-admin-dialog',
  templateUrl: './area-admin-dialog.component.html',
  styleUrls: ['./area-admin-dialog.component.scss'],
  standalone: true,
  imports: [
    LmsModalFrameComponent,
    FormsModule,
    ReactiveFormsModule,
    LMS_NoSpecialsDirective,
    UpperCaseInputDirective,
    NgIf,
    MdbRippleModule,
  ],
})
export class AreaAdminDialogComponent {
  areaForm = this.fb.group({
    region: '',
    areaCtrl: '',
  });
  submitted: boolean = false;
  areaRec: AreaModel;
  areaModel: AreaModel;

  constructor(public dialogRef: MdbModalRef<AreaAdminDialogComponent>, private fb: FormBuilder) {}

  get areaCtrl() {
    return this.areaForm?.controls?.areaCtrl;
  }

  ngOnInit(): void {
    this.submitted = true;
    this.areaModel = this.areaRec; // ? data?.area : {name: ''};

    this.areaForm.setValue({
      region: this.areaRec.region?.name || '',
      areaCtrl: this.areaRec.name || '',
    });
  }

  saveArea() {
    if (!this.areaForm.valid) {
      return;
    }

    this.dialogRef.close(this.areaCtrl.value);
  }

  close() {
    this.dialogRef.close();
  }
}
